// The purpose of this file is store form field constraints (rules, messages) for a HTML form.
// Note that this data is kept separate from the implementation of the system that stores and retrieves data,
// which is located in the 'core' directory.

// Grab a reference to the application data store object.
var dataStore = app.data;

// Create data and store it. Note that validation messages should be overriden by the server
// in the cshtml view files, to cater for different languages. The message values here are just fallbacks.
// Things should take the format of: fieldName[validatorType] = { message: "My custom message" } as per https://validatejs.org/

dataStore.set('validation.signInForm', {

    email: [
        {
            type: 'present',
            errorCode: 10047
        },
        {
            type: 'email',
            errorCode: 10090
        }
    ],
    password: [
        {
            type: 'present',
            errorCode: 10048
        }
    ]
});